import Widget from "@/components/widgets";
import type { WidgetConfig } from "@/types";
import { VerticalMarqeeGalleryComponentWidget } from "@/features/testimonial-gallery/components/verticalMarquee";

declare global {
  interface Window {
    VerticalMarqueeGalleryWidget: typeof VerticalMarqueeGalleryWidget;
  }
}

class VerticalMarqueeGalleryWidget extends Widget {
  static init(config: WidgetConfig) {
    return super.init(config, VerticalMarqeeGalleryComponentWidget);
  }
}

if (typeof window !== "undefined") {
  window.VerticalMarqueeGalleryWidget = VerticalMarqueeGalleryWidget;
}

export default VerticalMarqueeGalleryWidget;
